import * as React from 'react'

import useTopOffset from '../../../../hooks/useTopOffset'
import {getBuild} from '../../../../selectors'
import {getFullLogState} from '../../../packages/BuildLog/BuildLog.selectors'
import BuildLogDependenciesNavigation from '../../../packages/BuildLog/FullBuildLog/BuildLogDependenciesNavigation/BuildLogDependenciesNavigation'
import FullBuildLog from '../../../packages/BuildLog/FullBuildLog/FullBuildLog.container'

import type {Props} from './BuildLogTab.types'

import styles from './BuildLogTab.css'

import {useAppSelector} from 'src/hooks/react-redux'

export default function BuildLogTab({buildId}: Props) {
  const {topOffset, topOffsetRef} = useTopOffset()
  const parallelized = useAppSelector(state => getBuild(state, buildId)?.parallelized)
  const storedBuildId = useAppSelector(state => getFullLogState(state, 'page').buildId)
  const style = {
    height: topOffset != null ? `calc(100vh - ${topOffset}px)` : undefined,
  }

  if (storedBuildId == null) {
    return null
  }

  return (
    <div ref={topOffsetRef} className={styles.page} style={style}>
      {parallelized ? <BuildLogDependenciesNavigation buildId={buildId} /> : null}
      {topOffset != null && <FullBuildLog key={buildId} target="page" className={styles.log} />}
    </div>
  )
}
